<ng-container *ngLet="breakPointObserve$ | async as screenRes">
  <ng-container *ngIf="selectCatalog$ | async as selectedSet">
    <div
      class="container"
      [class.hidden]="hideHeader$ | async"
      [style.background]="
        selectedSet.archive
          ? 'repeating-linear-gradient(-45deg, var(--secondary-20-color), var(--secondary-20-color) 30px, var(--secondary-30-color) 30px, var(--secondary-30-color) 60px) fixed'
          : ''
      "
      [style.max-height]="screenRes === 250 && !mobilePaneHide ? '40px !important' : ''"
    >
      <div *ngLet="langChange$ | async" class="table-edge-margin header-container" [ngClass]="{ 'archive-header-container': selectedSet.archive }">
        <div class="title-container">
          <div class="first-column">
            <app-backward-btn
              [backwardTitle]="'DATA.CATALOG_ITEMS_DATA.HEADER.TO_LIST_DATASETS' | translate"
              [width]="getBackwardButtonWidth(screenRes)"
              [height]="catalogHeightCatalogName"
              link="/opendata"
              [titleName]="getHeaderTitle(selectedSet)"
              [templateRef]="screenRes === 250 ? notFoundObjTemp : null"
              [defaultTooltip]="false"
            ></app-backward-btn>
            <app-download-button
              [disable]="isNotPublicCatalog"
              [darkStyle]="true"
              [catalogId]="downloadCatalogId"
              [isDynamic]="selectedSet.isDynamic"
            ></app-download-button>
          </div>

          <div class="category-container" *ngIf="mobilePaneHide">
            <span [matTooltip]="isRuLocale ? selectedSet?.catalogName ?? '' : selectedSet?.catalogNameEn ?? ''" class="h4 mobile-title">{{ isRuLocale ? selectedSet?.catalogName : selectedSet?.catalogNameEn }}</span>
            <a
              class="link-3 category-name"
              [matTooltip]="'OTHER.FILTER_BY_CATEGORY' | translate"
              (click)="setCategoryFilter(selectedSet)"
              routerLink="/opendata"
            >
              {{ isRuLocale ? selectedSet?.categoryName : selectedSet?.categoryNameEn }}
            </a>
            <div class="rating-mobile-wrapper">
              <div *ngIf="!selectedSet.archive" class="rating-mobile-container">
                <app-rating
                    [disable]="isNotPublicCatalog"
                    [showNew]="false"
                    [smallIcons]="true"
                    [apprecatedCount]="selectedSet.numberVotes"
                    [isMobileRating]="true"
                    [rating]="selectedSet.rating"
                    [hasSaveRating]="true"
                  ></app-rating>
                <ng-container *ngTemplateOutlet="numberViewTmpl; context: { selectedSet: selectedSet }"></ng-container>
                <ng-container *ngTemplateOutlet="numberDownloadsTmpl; context: { selectedSet: selectedSet }"></ng-container>
              </div>
              <div class="relevance-data">
                <ng-container *ngTemplateOutlet="relevance; context: { selectedSet: selectedSet }"></ng-container>
                <ng-container *ngTemplateOutlet="notFoundObjTemp"></ng-container>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="selectedSet.archive" class="small-container archive-container">
          <div class="center mb4">
            <svg [icon]="screenRes > 625 ? icons.ArchiveFrame : icons.ArchiveFrame" class="inactive-color-50 mr8" [ngClass]="iconClass" />
            <span class="archive-text-icon caption-3">{{ screenRes === 250 ? ('OTHER.ARCH' | translate) : ('OTHER.ARCHIVE' | translate) }}</span>
          </div>

          <div>
            <span class="archive-text mb4">{{ 'DATA.CATALOG_ITEMS_DATA.HEADER.ARCHIVE' | translate }}</span>
          </div>
        </div>

        <div *ngIf="!selectedSet.archive" class="small-container rating-container">
          <span class="caption-1 mb8">{{ 'DATA.CATALOG_ITEMS_DATA.HEADER.RATING' | translate }}</span>
          <app-rating
            [disable]="isNotPublicCatalog"
            [showNew]="false"
            [apprecatedCount]="selectedSet.numberVotes"
            [rating]="selectedSet.rating"
            [hasSaveRating]="true"
          ></app-rating>
        </div>

        <div *ngIf="!selectedSet.archive" class="small-container number-view">
          <span class="caption-1 mb8">{{ 'DATA.CATALOG_ITEMS_DATA.HEADER.VIEWS' | translate }}</span>
          <span class="h3"> {{ selectedSet?.numberView }}</span>
        </div>

        <div *ngIf="!selectedSet.archive" class="small-container number-downloads">
          <span class="caption-1 mb8">{{ 'DATA.CATALOG_ITEMS_DATA.HEADER.DOWNLOADS' | translate }}</span>
          <span class="h3"> {{ selectedSet?.numberDownloads }}</span>
        </div>

        <div class="small-container relevance-pc">
          <span class="caption-1 mb8">{{ 'DATA.CATALOG_ITEMS_DATA.HEADER.RELEVANCE' | translate }}</span>
          <ng-container *ngTemplateOutlet="relevance; context: { selectedSet: selectedSet }"></ng-container>
        </div>

        <div class="notifications">
          <app-favorites-and-subscribe-catalog [disable]="isNotPublicCatalog" [isDynamic]="isDynamic" [catalogId]="catalogId">
          </app-favorites-and-subscribe-catalog>
        </div>

        <div class="export-container">
          <app-download-button
            [disable]="isNotPublicCatalog"
            [darkStyle]="true"
            [catalogId]="downloadCatalogId"
            [releaseDate]="downloadReleaseDate"
            [isDynamic]="selectedSet.isDynamic"
          ></app-download-button>
          <ng-container *ngTemplateOutlet="notFoundObjTemp"></ng-container>
        </div>
      </div>

      <ng-template #relevance let-selectedSet="selectedSet">
        <div class="relevance">
          <span class="h3">{{ selectedSet?.relevance }}</span>
          <div *ngIf="isMobileView && selectedSet.archive" class="btn-with-icon mt4" (click)="stopPropagation($event)">
            <svg [icon]="screenRes > 625 ? icons.Archive18 : icons.Archive" class="primary-color mr8" [ngClass]="iconClass" />
            <span class="caption-4 primary-color">{{ 'OTHER.ARCHIVE' | translate }}</span>
          </div>

          <div *ngIf="isDynamic" class="btn-with-icon mt2" (click)="stopPropagation($event)">
            <svg [icon]="icons.Dynamic" class="dynamic-icon inactive-color mr8" [ngClass]="iconClass" />
            <span class="caption-4 dynamic-text">{{ 'DATA.TABLE_FILTER.DYNAMIC' | translate }}</span>
          </div>
        </div>
      </ng-template>

      <ng-template #numberViewTmpl let-selectedSet="selectedSet">
        <div class="btn-with-icon" *ngIf="!selectedSet.archive" (click)="stopPropagation($event)">
          <svg [icon]="icons.Viewed18" class="mr8 inactive-color" [ngClass]="iconClass" />
          <span class="h3"> {{ selectedSet?.numberView }}</span>
        </div>
      </ng-template>

      <ng-template #numberDownloadsTmpl let-selectedSet="selectedSet">
        <div class="btn-with-icon" *ngIf="!selectedSet.archive" (click)="stopPropagation($event)">
          <svg [icon]="icons.Downloaded18" class="mr8 inactive-color" [ngClass]="iconClass" />
          <span class="h3"> {{ selectedSet?.numberDownloads }}</span>
        </div>
      </ng-template>

      <ng-template #notFoundObjTemp>
        <span *ngIf="!isNotPublicCatalog && isRuLocale">
          <a
            *ngIf="!isDynamic && !selectedSet.archive"
            class="not-found btn-with-icon mt20"
            [routerLink]="newObjectPage"
            [queryParams]="newObjectPageParams"
          >
            <svg [icon]="icons.Question" class="svg18 mr8" />
            <span class="link-3">{{ 'DATA.CATALOG_ITEMS_DATA.HEADER.CANT_FIND_ITEM' | translate }}</span>
          </a>
        </span>
      </ng-template>
    </div>
    <nav
      *ngLet="filter$ | async"
      [style.background]="
        selectedSet.archive
          ? 'repeating-linear-gradient(-45deg, var(--secondary-20-color), var(--secondary-20-color) 30px, var(--secondary-30-color) 30px, var(--secondary-30-color) 60px) fixed'
          : ''
      "
      mat-tab-nav-bar
      class="tabs-menu table-edge-margin"
      [class.hidden]="hideHeader$ | async"
    >
      <a
        mat-tab-link
        *ngFor="let link of navLinks"
        [routerLink]="link.link"
        [queryParams]="link?.params"
        routerLinkActive
        #rla="routerLinkActive"
        [active]="link.url === activeLink"
      >
        {{ link.label | translate }}
      </a>

      <button *ngIf="screenRes <= 200 || arrowShow" class="btn-empty btn-with-icon mr4 mlA" (click)="showHideMobileHeader()">
        <svg [icon]="mobilePaneHide ? icons.ExpandMoreUp : icons.ExpandMoreDown" class="svg24 dark-gray-color" />
      </button>
    </nav>
  </ng-container>
</ng-container>
